import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Select, MenuItem, Typography, InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";
import ReactCountryFlag from "react-country-flag";
import LoadingOverlay from "./LoadingOverlay";

const LANGUAGES = [
  { code: "en", label: "English", country: "US", direction: "ltr" },
  { code: "ar", label: "العربية", country: "IQ", direction: "rtl" },
];

const DOMAIN = window.location.hostname === "localhost" ? ".localhost" : ".justenant.com";

const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: 120,
  borderRadius: 24,
  background: theme.palette.mode === "dark" ? "#22304b" : "#fff",
  color: theme.palette.text.primary,
  ".MuiSelect-select": {
    padding: "8px 36px 8px 36px",
    display: "flex",
    alignItems: "center",
  },
  "& .MuiSvgIcon-root": {
    right: 8,
    color: theme.palette.text.secondary,
  },
  "& fieldset": {
    border: "none",
  },
}));

export default function LangSwitcher() {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Clear any stale googtrans cookie that causes Google Translate to interfere
    document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `googtrans=; path=/; domain=${DOMAIN}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

    const lang = i18n.language;
    setCurrentLang(lang);
    const langObj = LANGUAGES.find((l) => l.code === lang);
    document.body.dir = langObj?.direction || "ltr";
    document.documentElement.lang = langObj?.code || "en";
  }, []);

  const handleLanguageChange = (event) => {
    const lang = event.target.value;
    setCurrentLang(lang);
    setLoading(true);
    i18n.changeLanguage(lang); // automatically saves to localStorage via LanguageDetector

    const langObj = LANGUAGES.find((l) => l.code === lang);
    document.body.dir = langObj?.direction || "ltr";
    document.documentElement.lang = langObj?.code || "en";

    setTimeout(() => {
      const cleanUrl = window.location.origin + window.location.pathname;
      window.location.href = cleanUrl;
    }, 300);
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <Box display="flex" alignItems="center" gap={1}>
        <StyledSelect
          value={currentLang}
          onChange={handleLanguageChange}
          variant="outlined"
          size="small"
          input={<InputBase />}
          MenuProps={{
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            PaperProps: { style: { minWidth: 140 } },
          }}
        >
          {LANGUAGES.map(({ code, label, country }) => (
            <MenuItem
              key={code}
              value={code}
              style={{ display: "flex", alignItems: "center" }}
              className="notranslate"
            >
              <ReactCountryFlag
                countryCode={country}
                svg
                style={{
                  width: "1.3em",
                  height: "1em",
                  marginInlineEnd: 10,
                  borderRadius: 2,
                }}
                title={label}
                className="notranslate"
              />
              <Typography
                component="span"
                fontSize={14}
                className="notranslate"
              >
                {label}
              </Typography>
            </MenuItem>
          ))}
        </StyledSelect>
      </Box>
    </>
  );
}
